import React from 'react';
import DictionaryDropdown from './DictionaryDropdown';

const selectedDictionaries = (dictionaries, byCode) => dictionaries
  .filter((r) => (r.selected === true))
  .map((r) => (byCode ? r.code : r.uuid));

const DictionariesDropdown = ({
  byCode,
  className,
  dictionaries,
  disabled,
  errors = [],
  message,
  onChange,
  readStatus,
}) => (
  <DictionaryDropdown
    byCode={byCode}
    className={className}
    dictionaries={dictionaries}
    disabled={disabled}
    errors={errors}
    message={message}
    multiple
    onChange={onChange}
    readStatus={readStatus}
    value={selectedDictionaries(dictionaries, byCode)}
  />
);

export default DictionariesDropdown;
